var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup428(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 15,
    viewBox: "0 0 19.5 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3788",
    "data-name": "Path 3788",
    d: "M-438.049,251.239c.089.046.155.077.217.114q4.531,2.689,9.06,5.383a.844.844,0,0,0,.951-.007q4.536-2.7,9.079-5.391c.051-.03.1-.057.184-.1v.231q0,4.718,0,9.437a1.335,1.335,0,0,1-1.36,1.435h-16.767a1.333,1.333,0,0,1-1.364-1.43q0-4.718,0-9.437Z",
    transform: "translate(438.053 -247.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    "data-name": "Path 3789",
    d: "M-428.405,159.8h8.345a1.338,1.338,0,0,1,1.4,1.461c0,.22-.01.441,0,.66a.282.282,0,0,1-.165.3q-2.725,1.594-5.446,3.2-1.98,1.163-3.958,2.33a.3.3,0,0,1-.349.005q-4.708-2.775-9.421-5.538a.266.266,0,0,1-.159-.277c.014-.312-.019-.628.015-.937a1.313,1.313,0,0,1,1.311-1.2Q-432.619,159.8-428.405,159.8Z",
    transform: "translate(438.159 -159.797)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup428);
export default __webpack_public_path__ + "static/media/Group 428.bad6da9c8edd14b07cad1e5e9540f96a.svg";
export { ForwardRef as ReactComponent };